import { observer } from "mobx-react";
import { Box, Typography } from "@mui/material";
import ContentBlock from "../components/ContentBlock";
import AntibioticEntryForm from "../components/forms/antibiotika/AntibioticEntryForm";
import AntibioticDayList from "../components/lists/AntibioticDayList";
import { useState } from "react";
import { Treatment } from "../models/Treatments";
import InfoText from "../components/typographies/InfoText";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const Antibiotics = observer(() => {
  const { t } = useTranslation();
  const [selectedDay, setSelectedDay] = useState<any | undefined>(undefined);

  const handleSelectDay = (day: Treatment) => {
    const initialData = {
      ...day,
      startDate: dayjs(day.startDate).format("YYYY-MM-DD"),
      endDate: day.endDate ? dayjs(day.endDate).format("YYYY-MM-DD") : "",
    };
    setSelectedDay(initialData);
  };

  return (
    <Box className="page-container">
      <Box sx={{ marginBottom: 2 }}>
        <InfoText text={t("antibiotics.info")} />
      </Box>
      <ContentBlock title="Registrera: Antibiotika" icon="edit" bottomMargin>
        <AntibioticEntryForm
          selectedDay={selectedDay}
          onDeSelect={() => setSelectedDay(undefined)}
        />
      </ContentBlock>
      <ContentBlock title="Antibiotika" icon="list">
        <Box sx={{ marginTop: 2, marginBottom: 4 }}>
          <Typography variant="h6">
            Röd bakgrund betyder att du inte satt något slutdatum på den ännu.
            Det kan du göra genom att trycka på "Redigera".
          </Typography>
        </Box>
        <AntibioticDayList onClick={handleSelectDay} />
      </ContentBlock>
    </Box>
  );
});

export default Antibiotics;
